(function(config) {
    'use strict';

    angular.module('ksef.services', ['ngResource'])
        .factory('ksefCompanyDataSrvc', ksefCompanyDataSrvc)
        .factory('ksefCertificateDataSrvc', ksefCertificateDataSrvc)
        .factory('ksefCertificateSrvc', ksefCertificateSrvc)
        .factory('ksefInvoiceDataSrvc', ksefInvoiceDataSrvc)
        .factory('ksefInvoiceSrvc', ksefInvoiceSrvc);

    ksefCompanyDataSrvc.$inject = ['$resource'];

    function ksefCompanyDataSrvc($resource) {
        return $resource(config.api + '/api/v1/ksef/companies/:pk/', { pk: '@pk' }, {
            get: {
                method: 'GET'
            },
            list: {
                method: 'GET',
                params: {
                    page: '@page'
                }
            },
            create: {
                method: 'POST'
            },
            activateConnection: {
                method: 'POST',
                url: config.api + '/api/v1/ksef/companies/:pk/activate_connection/'
            },
            update: {
                method: 'PATCH'
            },
            delete: {
                method: 'DELETE'
            },
            getCerts: {
                method: 'GET',
                url: config.api + '/api/v1/ksef/companies/:pk/certificates/'
            }
        });
    }

    ksefCertificateDataSrvc.$inject = ['$resource', 'transformRequestSrvc'];

    function ksefCertificateDataSrvc($resource, transformRequestSrvc) {
        return $resource(config.api + '/api/v1/ksef/certificates/:pk/', { pk: '@pk' }, {
            create: {
                method: 'POST',
                headers: { 'Content-Type': undefined },
                transformRequest: transformRequestSrvc.formDataTransform
            },
            delete: {
                method: 'DELETE'
            }
        });
    }

    ksefCertificateSrvc.$inject = ['ksefCertificateDataSrvc', 'modalSrvc'];

    function ksefCertificateSrvc(ksefCertificateDataSrvc, modalSrvc) {
        return {
            remove: remove,
        };

        function remove(title, pk, successCallback, errorCallback) {
            modalSrvc.confirmRemove(
                title,
                function() {
                    ksefCertificateDataSrvc.delete({pk: pk}).$promise.then(successCallback, errorCallback);
                }
            );
        }
    }

    ksefInvoiceDataSrvc.$inject = ['$resource'];

    function ksefInvoiceDataSrvc($resource) {
        return $resource(config.api + '/api/v1/ksef/invoices/:pk/', { pk: '@pk' }, {
            getFieldOpts: {
                method: 'GET',
                url: config.api + '/api/v1/ksef/invoices/status_opts/',
                isArray: true
            },
            getUnsentInvoicesCount: {
                method: 'GET',
                url: config.api + '/api/v1/ksef/invoices/unsent_count/'
            }
        });
    }

    ksefInvoiceSrvc.$inject = ['$uibModal'];

    function ksefInvoiceSrvc($uibModal) {
        return {
            invoiceUnsentModal: invoiceUnsentModal
        };

        function invoiceUnsentModal(dataObj, okCallback, cancelCallback) {
            $uibModal.open({
                templateUrl: 'app/ksef/views/invoices-unsent-modal/invoices-unsent-modal.html',
                // templateUrl: 'app/allegro/views/category-select-modal/category-select-modal.html',
                controller: 'KSeFInvoiceUnsentModalController',
                controllerAs: 'ctrl',
                size: 'md',
                windowClass: 'invoice-modal',
                resolve: {
                    dataObj: function () {
                        return dataObj;
                    }
                }
            }).result.then(okCallback, cancelCallback);
        }
    }

})(window.config);
